import * as XLSX from 'xlsx';

const formatDateTimeBR = (iso) => {
    if (!iso) return ' - ';
    const d = new Date(iso);
    if (isNaN(d.getTime())) return ' - ';
    return d.toLocaleString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
    });
};

const exportToExcel = (data, fileName = 'Acertos Futuros.xlsx') => {
    if (!Array.isArray(data) || data.length === 0) {
        console.error('Invalid data: Expected a non-empty array.');
        return;
    }

    const formattedData = data.map(
        ({
            seller,
            pay_date,
            kit_number,
            is_checked,
            total_value,
            generated_bill,
            generated_last_date_bill,
            generated_bill_counter,
            case_model
        }) => {
            // Pay date "YYYY-MM-DD" -> dd/mm/aaaa
            let payDateStr = ' - ';
            if (pay_date) {
                const [year, month, day] = String(pay_date).split('-'); // "YYYY-MM-DD"
                if (year && month && day) {
                    const localDate = new Date(Number(year), Number(month) - 1, Number(day));
                    payDateStr = localDate.toLocaleDateString('pt-BR');
                }
            }

            return {
                'Vendedor': seller?.nome || '',
                'Data de Pagamento': payDateStr,
                'Número do Kit': kit_number ?? '',
                'Verificado': is_checked ? 'Sim' : 'Não',
                'Valor Total': Number(total_value) || 0,
                // NOVAS COLUNAS
                'Fatura Gerada?': generated_bill ? 'Sim' : 'Não',
                'Data Fatura Gerada': formatDateTimeBR(generated_last_date_bill),
                'Qtde Gerações': Number(generated_bill_counter) || 0,
                'Case': case_model || ' - '
            };
        }
    );

    // Worksheet
    const worksheet = XLSX.utils.json_to_sheet(formattedData);

    // Larguras das colunas (8 colunas agora)
    worksheet['!cols'] = [
        { wch: 30 }, // A Vendedor
        { wch: 18 }, // B Data de Pagamento
        { wch: 14 }, // C Número do Kit
        { wch: 12 }, // D Verificado
        { wch: 16 }, // E Valor Total
        { wch: 16 }, // F Fatura Gerada?
        { wch: 22 }, // G Data Fatura Gerada
        { wch: 14 }, // H Qtde Gerações
        { wch: 14 }, // I Case Model
    ];

    // Centraliza colunas: B, C, D, F, G, H (índices 1,2,3,5,6,7)
    const range = XLSX.utils.decode_range(worksheet['!ref']);
    const centerCols = [1, 2, 3, 5, 6, 7];
    for (const col of centerCols) {
        for (let row = 0; row <= range.e.r; row++) {
            const cellAddress = XLSX.utils.encode_cell({ r: row, c: col });
            if (worksheet[cellAddress]) {
                worksheet[cellAddress].s = {
                    ...(worksheet[cellAddress].s || {}),
                    alignment: { horizontal: 'center' },
                };
            }
        }
    }

    // Formatar moeda na coluna "Valor Total" (E = índice 4)
    for (let row = 1; row <= range.e.r; row++) {
        const cellAddress = XLSX.utils.encode_cell({ r: row, c: 4 });
        if (worksheet[cellAddress]) {
            worksheet[cellAddress].z = '#,##0.00';
        }
    }

    // Cabeçalho explícito (garante ordem e títulos)
    const header = [[
        'Vendedor',
        'Data de Pagamento',
        'Número do Kit',
        'Verificado',
        'Valor Total',
        'Fatura Gerada?',
        'Data Fatura Gerada',
        'Qtde Gerações',
        'Case Model'
    ]];
    XLSX.utils.sheet_add_aoa(worksheet, header, { origin: 'A1' });

    // Workbook
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Data');

    // Arquivo
    XLSX.writeFile(workbook, fileName);
};

export default exportToExcel;